/**
 * Product helper
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */

'use strict';

export default class {

    constructor() {

        App.dispatcher.listen('breakpoint.xs', () => {
            this.hideAll();            
        });

        App.dispatcher.listen('breakpoint.sm', () => {
            this.showAll();
        });

    }

    showDescription() {
        document.getElementById('collapse-description').classList.add("show");
    }

    hideDescription() {
        document.getElementById('collapse-description').classList.remove("show");
    }

    showSpecs() {
        document.getElementById('collapse-specs').classList.add("show");
    }

    hideSpecs() {
        document.getElementById('collapse-specs').classList.remove("show");
    }

    showAll() {
        this.showDescription();
        this.showSpecs();
    }

    hideAll() {
        this.hideDescription();
        this.hideSpecs();
    }

}